module.exports = __webpack_public_path__ + "img/phonepe.1f17ac49.jpeg";